<template>
  <v-container grid-list-xs background fluid>
    <v-layout row wrap text-xs-center my-2>
      <!-- desktop -->
      <v-flex v-for="(data,j) in dataEmployee" :key="j" xs12 px-2>
        <v-layout row wrap text-xs-center my-2>
          <v-flex md12 sm12 xs12 pa-2 style="margin-top:-5px;">
            <!-- <v-layout>
              <v-flex md12 sm12 xs12 pa-2>
                <v-btn color="indigo darken-4" style="height: 150px" block dark large>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 text-xs-left style="margin-top:10px;">
                        <v-icon fab dark small style="font-size:1.5em;">fa fa-calendar-alt</v-icon>
                        <span>
                          <strong
                            style="font-size:1.5em;"
                          >&nbsp;{{dateformat(date_picker_model.date)}}</strong>
                        </span>
                      </v-flex>
                      <v-flex xs12 text-xs-right style="margin-top:-10px;">
                        <span>
                          <strong style="font-size:3em;width:250px;">{{currentTime}}</strong>
                        </span>
                        <br />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-btn>
              </v-flex>
              <v-flex md12 sm12 xs12>
                <v-layout row wrap v-if="dataSalary == '' && time == 0">
                  <v-flex
                    xs12
                    text-xs-right
                    class="white--text hidden-xs-only"
                    style="margin-top:-10px;"
                  >
                    <span>
                      <strong style="font-size:1.1em;">&nbsp;{{dateformat(date_picker_model.date)}}</strong>
                    </span>
                    <br />
                    <span>
                      <strong style="font-size:0.9em;width:250px;margin-left:5px;">{{currentTime}}</strong>
                    </span>
                  </v-flex>
                  <v-flex
                    xs12
                    text-xs-right
                    class="white--text hidden-sm-and-up"
                    style="margin-top:-10px;"
                  >
                    <span>
                      <strong style="font-size:1.1em;">&nbsp;{{dateformat(date_picker_model.date)}}</strong>
                    </span>

                    <span>
                      <strong style="font-size:0.9em;width:250px;margin-left:5px;">{{currentTime}}</strong>
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>-->

            <v-flex lg12 md12 sm12 xs12>
              <v-layout row wrap>
                <!-- WORKPLAN -->
                <v-flex lg8 md12 sm12 xs12 pa-1>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card
                        max-width="100%"
                        class="mx-auto display"
                        style="background-color:#FAFAFA;border-radius:10px;"
                      >
                        <v-toolbar flat>
                          <v-toolbar-title>
                            <span>{{$t('Salary')}}</span>
                          </v-toolbar-title>
                        </v-toolbar>

                        <v-divider></v-divider>
                        <v-card-text>
                          <v-layout row wrap lg12 md12 sm12 xs12 pa-2>
                            <v-flex lg4 md6 sm12 xs12 text-xs-center pa-1 v-if="dataSalary != ''">
                              <Doughnut
                                :data="chartData"
                                :options="chartOptions"
                                :height="200"
                                :width="100"
                              ></Doughnut>
                            </v-flex>
                            <v-flex offset-lg2 lg6 md6 sm12 xs12 text-xs-left pa-2>
                              <v-layout row wrap>
                                <v-flex xs12 pa-1>
                                  <span style="font-size:0.8em;">{{$t('CurrentSalary')}} :</span>
                                  <br />
                                  <span
                                    style="color:#3F51B5;font-size:1.5em;"
                                  >{{thousandSep(data.current_salary)}}&nbsp;{{$t('baht')}}</span>
                                  <br />
                                </v-flex>
                                <v-flex xs12 pa-1 style="margin-top:12px;margin-bottom:12px;">
                                  <v-divider></v-divider>
                                </v-flex>
                                <v-flex lg6 xs6 pa-1 v-if="dataSalary == ''">
                                  <span
                                    style="color:#000000;font-size:1.5em;"
                                  >คุณยังไม่มีเอกสารเงินเดือน</span>
                                  <br />
                                </v-flex>
                                <v-flex lg6 xs6 pa-1 v-if="dataSalary != ''">
                                  <span style="font-size:0.8em;">{{$t('TotalIncome')}} :</span>
                                  <br />
                                  <span
                                    style="color:#009688;font-size:1.5em;"
                                  >{{thousandSep(dataSalary[0].totalEarning)}}&nbsp;{{$t('baht')}}</span>
                                  <br />
                                </v-flex>
                                <v-flex lg6 xs6 pa-1 v-if="dataSalary != ''">
                                  <span style="font-size:0.8em;">{{$t('TotalDeduct')}} :</span>
                                  <br />
                                  <span
                                    style="color:#F44336;font-size:1.5em;"
                                  >{{thousandSep(dataSalary[0].totalDeduct)}}&nbsp;{{$t('baht')}}</span>
                                  <br />
                                </v-flex>
                                <v-flex lg6 xs6 pa-1 v-if="dataSalary != ''">
                                  <span style="font-size:0.8em;">{{$t('LastSalary')}} :</span>
                                  <br />
                                  <span
                                    style="color:#FF5722;font-size:1.5em;"
                                  >{{thousandSep(dataSalary[0].total_balance)}}&nbsp;{{$t('baht')}}</span>
                                  <br />
                                </v-flex>
                                <v-flex
                                  xs12
                                  text-xs-right
                                  style="font-size:2em;"
                                  @click="showPayslip(dataSalary[0].docNo,dataSalary[0].code)"
                                >
                                  <v-btn
                                    color="info"
                                    outlined 
                                  > 
                                  
                                   <p style="margin-top:10px; margin-bottom:10px; color:#ffffff;">
                                      <v-icon>fas fa-print</v-icon>
                                      &nbsp;{{$t('PaySlip')}}
                                    </p>
                                   
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <!-- <v-flex lg6 md12 sm12 xs12 pa-2>
                              <v-card
                                max-width="100%"
                                class="mx-auto"
                                style="padding:20px;border-left:5px solid #43A047; background-color:#FAFAFA;border-radius:10px;"
                              >
                                <v-card-title>
                                  <v-icon
                                    fab
                                    dark
                                    small
                                    style="font-size:1em;color:#000;"
                                  >fas fa-money-bill</v-icon>
                                  <span>
                                    <strong style="font-size:1em;">&nbsp;{{$t('LastSalary')}}</strong>
                                  </span>
                                </v-card-title>
                                <v-card-text>
                                  <v-flex xs12 text-xs-right style="font-size:2em;">
                                    <p>{{thousandSep(dataSalary[0].total_balance)}}&nbsp;{{$t('baht')}}</p>
                                  </v-flex>
                                </v-card-text>
                                <v-card-actions>
                                  <v-flex
                                    xs12
                                    text-xs-right
                                    style="font-size:2em;"
                                    @click="showPayslip(datasalary.docNo,datasalary.code)"
                                  >
                                    <v-btn style="height:50px">
                                      <p
                                        style="margin-top:10px; margin-bottom:10px; color:#616161;"
                                      >
                                        <v-icon>fas fa-print</v-icon>
                                        &nbsp;{{$t('PaySlip')}}
                                      </p>
                                    </v-btn>
                                  </v-flex>
                                </v-card-actions>
                              </v-card>
                            </v-flex>-->
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex lg4 md12 sm12 xs12>
                  <v-flex xs12 pa-1>
                    <v-card
                      max-width="100%"
                      class="mx-auto"
                      style="background-color:#FAFAFA;border-radius:10px;"
                      height="170px"
                    >
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <span style="font-size:0.8em;">{{$t('startworkdate')}}</span>
                        </v-toolbar-title>
                      </v-toolbar>

                      <v-divider></v-divider>
                      <v-card-text>
                        <v-layout row warp pa-2>
                          <v-flex lg8 md8 sm8 xs6 text-xs-left pa-1>
                            <span style="font-size:2em;">{{dayWorklog(data.start_work_date)}}</span>
                          </v-flex>

                          <v-flex lg4 md4 sm4 xs6 text-xs-left pa-1>
                            <span>{{$t('workingperiod')}} :</span>
                            <br />
                            <span
                              style="color:#009688;font-size:1.5em;"
                            >{{dateformNow(data.start_work_date)}}</span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 pa-1>
                    <v-card
                      max-width="100%"
                      class="mx-auto"
                      style="background-color:#FAFAFA;border-radius:10px;"
                      height="220px"
                    >
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <span style="font-size:0.8em;">{{$t('menu.WorkPlanList')}}</span>
                        </v-toolbar-title>
                      </v-toolbar>

                      <v-divider></v-divider>
                      <v-card-text>
                        <v-layout row warp pa-2>
                          <v-flex lg8 md8 sm8 xs6 text-xs-left pa-1>
                            <span
                              style="font-size:1em;"
                            >{{$t(dateWorklog(date_picker_model.date))}},</span>
                            <br />
                            <span style="font-size:1em;">{{$t(dayWorklog(date_picker_model.date))}}</span>
                            <br />
                            <span style="font-size:2.5em;color:#01579B;">{{currentTime}}</span>
                            <br />
                          </v-flex>
                          <v-flex lg4 md4 sm4 xs6 text-xs-left pa-1 v-if="time == 1 ">
                            <span>{{$t('Clock in time :')}}</span>
                            <br />
                            <span
                              style="color:#009688;font-size:1.5em;"
                              v-if="clockinTime  != ''"
                            >{{clockinTime}}</span>
                            <br />
                            <span>{{$t('Clock out time :')}}</span>
                            <br />
                            <span
                              style="color:#FF5722;font-size:1.5em;"
                              v-if="clockoutTime != ''"
                            >{{clockoutTime}}</span>
                            <br />
                          </v-flex>
                          <v-flex lg4 md4 sm4 xs6 text-xs-left pa-1 v-if="time == 0 ">
                            <span style="color:#000000;font-size:1em;">คุณยังไม่มีแผนการทำงาน</span>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-flex>
                <!-- /ขาด ลา มาสาย/ -->
                <v-flex class="hidden-sm-and-up" lg3 md3 sm6 xs12 pa-1 v-if="time == 1 ">
                  <v-card
                    max-width="100%"
                    class="mx-auto"
                    style="background-color:#FAFAFA;border-radius:10px;"
                  >
                    <v-card-text>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:2em;">&nbsp;{{$t('TotalAdsenceHour')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="teal darken-2" size="32">
                            <span
                              class="white--text"
                              style="font-size:2em;"
                            >{{total_Deduct.totalAbsent}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:2em;">&nbsp;{{$t('TotalLeaveHours')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="blue darken-2" size="32">
                            <span
                              class="white--text"
                              style="font-size:2em;"
                            >{{total_Deduct.totalLeaveEvent}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:2em;">&nbsp;{{$t('TotalLate')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="pink darken-2" size="32">
                            <span
                              class="white--text"
                              style="font-size:2em;"
                            >{{total_Deduct.totalLate}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:2em;">&nbsp;{{$t('TotalOutBeforeTime')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="orange darken-4" size="32">
                            <span
                              class="white--text"
                              style="font-size:2em;"
                            >{{total_Deduct.totalOutbefore}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex lg3 md3 sm6 xs12 pa-1 hidden-xs-only v-if="time == 1 ">
                  <v-card
                    max-width="100%"
                    class="mx-auto"
                    style="background-color:#FAFAFA;border-radius:10px;"
                  >
                    <v-card-text>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:1em;">&nbsp;{{$t('TotalAdsenceHour')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="teal darken-2" size="48">
                            <span class="white--text headline">{{total_Deduct.totalAbsent}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex lg3 md3 sm6 xs12 pa-1 hidden-xs-only v-if="time == 1 ">
                  <v-card
                    max-width="100%"
                    class="mx-auto"
                    style="background-color:#FAFAFA;border-radius:10px;"
                  >
                    <v-card-text>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:1em;">&nbsp;{{$t('TotalLeaveHours')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="blue darken-2" size="48">
                            <span class="white--text headline">{{total_Deduct.totalLeaveEvent}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex lg3 md3 sm6 xs12 pa-1 hidden-xs-only v-if="time == 1 ">
                  <v-card
                    max-width="100%"
                    class="mx-auto"
                    style="background-color:#FAFAFA;border-radius:10px;"
                  >
                    <v-card-text>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:1em;">&nbsp;{{$t('TotalLate')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="pink darken-2" size="48">
                            <span class="white--text headline">{{total_Deduct.totalLate}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex lg3 md3 sm6 xs12 pa-1 hidden-xs-only v-if="time == 1 ">
                  <v-card
                    max-width="100%"
                    class="mx-auto"
                    style="background-color:#FAFAFA;border-radius:10px;"
                  >
                    <v-card-text>
                      <v-layout row warp pa-2>
                        <v-flex lg10 sm8 xs10 text-xs-left pa-1>
                          <span style="font-size:1em;">&nbsp;{{$t('TotalOutBeforeTime')}}</span>
                        </v-flex>

                        <v-flex lg2 sm4 xs2 text-xs-left pa-1>
                          <v-avatar color="orange darken-4" size="48">
                            <span class="white--text headline">{{total_Deduct.totalOutbefore}}</span>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import moment from "moment";
import EmployeeService from "@/services/EmployeeService";
import PayrollService from "@/services/PayrollService";
import ProcessService from "@/services/ProcessService";
import DocumentService from "@/services/DocumentService";
import Doughnut from "@/chart/DoughnutChart";
export default {
  data: () => ({
    date_picker_model: {
      date: new Date().toISOString().slice(0, 10),
      toggle: false
    },
    total_Deduct: [],
    Branch: "",
    Department: "",
    Position: "",
    Search: "",
    from_date: "",
    to_date: "",
    emp_code: "",
    time: 0,
    startDateOfCalendar: "",
    endDateOfCalendar: "",
    showAlert: false,
    currentTime: null,
    formatdate: 0,
    startdialog: false,
    clockinTime: "",
    clockoutTime: "",
    e1: 1,
    dataEmployee: [],
    dataSalary: [],
    filterDialog: false,
    incomeAndExpenses: [],
    sheet: false,
    totalEarning: 0,
    totalDeduct: 0,
    total_balance: 0,
    tiles: [
      { icon: "fas fa-file-medical", title: "menu.TakeLeaveList" },
      { icon: "fas fa-file-medical", title: "menu.ChangePlanList" },
      { icon: "fas fa-file-medical", title: "menu.OTPlanList" },
      { icon: "fas fa-file-medical", title: "menu.ReSignList" }
    ],
    bottomNav: "nearby",
    lang: "",
    chartData: {
      labels: ["รายรับ", "หักค่าใช้จ่าย", "คงเหลือ"],
      datasets: [
        {
          backgroundColor: ["#009688", "#DD1B16", "#E46651"],
          data: []
        }
      ]
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false
    },
    legend: {
      display: false
    }
  }),
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    ...mapState("app", ["formatDates"])
  },
  components: { Doughnut },
  created: function() {
    let v = this;
    this.commitSetToolbar({ patternTool: "0" });
    this.commitSetShowLoading(false);
    this.currentTime = moment().format("HH:mm:ss");
    this.getEmployee();
    this.checkplantoday();
    this.lang = localStorage.lang;
    this.time = localStorage._is_timeattendance;
    console.log("fffff", localStorage.lang);
    this.showdata(localStorage._empcode);
    this.showsalarydetail(localStorage._empcode);
    this.formatdate = this.formatDates;
    setTimeout(function() {
      console.log(v.Employee_List.length);
      if (v.Employee_List.length == 0) {
        v.startdialog = true;
      }
    }, 5000);
    console.log(this.formatdate);
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", [
      "commitSetToolbar",
      "commitSetShowLoading",
      "getFormatDate"
    ]),
    goto(path) {
      this.$router.push(path);
    },
    dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    dateWorklog(date) {
      return moment(date).format("dddd");
    },
    // dayWorklog(date) {
    //    var mount = moment(date).format("MMMM");

    //   return  mount
    // },
    dayWorklog(date, format) {
      let v = this;
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var monthsTH = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
      ];
      var d = new Date(date),
        month = "" + d.getMonth(),
        date = "" + d.getDate(),
        days = d.getDay();
      if (localStorage.getItem("lang") == "th") {
        var m = monthsTH[month];
        var year = d.getFullYear() + 543;
      }
      if (localStorage.getItem("lang") == "en") {
        var m = months[month];
        var day = Days[days];
        var year = d.getFullYear();
      }

      return [date, m, year].join(" ");
    },
    dateformNow(date) {
      var setdaystartwork = moment(date);
      var setNowDate = moment();
      var yearData = setNowDate.diff(setdaystartwork, "years", true);
      var yearFinal = Math.round(
        setNowDate.diff(setdaystartwork, "years", true),
        0
      );
      var yearReal = setNowDate.diff(setdaystartwork, "years");
      var monthDiff = Math.floor((yearData - yearReal) * 12);

      var monthData = setNowDate.diff(setdaystartwork, "month", true);
      var monthReal = setNowDate.diff(setdaystartwork, "month");
      var dateDiff = Math.floor((monthData - monthReal) * 30);

      if (localStorage.lang == "en") {
        if (yearReal == 0) {
          var str_year_month = monthDiff + " Month " + dateDiff + " Day ";
        } else if (monthDiff == 0) {
          var str_year_month = yearReal + " Year " + dateDiff + " Day ";
        } else if (dateDiff == 0) {
          var str_year_month = yearReal + " Year " + monthDiff + " Month ";
        } else {
          var str_year_month =
            yearReal + " Year " + monthDiff + " Month " + dateDiff + " Day ";
        }
      } else {
        if (yearReal == 0) {
          var str_year_month = monthDiff + " เดือน " + dateDiff + " วัน ";
        } else if (monthDiff == 0) {
          var str_year_month = yearReal + " ปี " + dateDiff + " วัน ";
        } else if (dateDiff == 0) {
          var str_year_month = yearReal + " ปี " + monthDiff + " เดือน ";
        } else {
          var str_year_month =
            yearReal + " ปี " + monthDiff + " เดือน " + dateDiff + " วัน ";
        }
      }
      return str_year_month;
    },
    updateCurrentTime() {
      this.currentTime = moment().format("HH:mm:ss");
    },
    onComplete() {
      this.onSaveCompanyAddress();
      this.onSaveGeneralSetting();
      this.onSaveTaxSetting();
      this.goto("dashboard");
    },
    showdata(data) {
      EmployeeService.getEmployeeDetail(data).then(res => {
        this.dataEmployee.push(res.data);
        console.log("res", this.dataEmployee);
        (this.Branch = this.dataEmployee[0].branch),
          (this.Department = this.dataEmployee[0].department),
          (this.Position = this.dataEmployee[0].position);
        this.setshowhourlateabsenceleave();
      });
    },
    showsalarydetail(data) {
      PayrollService.getDocDetailByEmp(data).then(res => {
        //console.log("res",res)
        if (res.data != "") {
          this.dataSalary.push(res.data[0]);
          var result = [];
          this.dataSalary.forEach(el => {
            el.incomeAndExpenses.forEach(element => {
              if (!this[element.name] && !this[element.tranFlag]) {
                this[element.name] = {
                  name: element.name,
                  amount: 0,
                  tranFlag: element.tranFlag
                };
                result.push(this[element.name]);
              }
              this[element.name].amount += element.amount;
            }, Object.create(null));
            this.incomeAndExpenses = result;
            console.log(result);
          });
          console.log(this.dataSalary);
          this.totalEarning = this.dataSalary[0].totalEarning;
          this.totalDeduct = this.dataSalary[0].totalDeduct;
          this.total_balance = this.dataSalary[0].total_balance;
          this.chartData.datasets[0].data = [
            this.totalEarning,
            this.totalDeduct,
            this.total_balance
          ];
          console.log(this.totalEarning);
          console.log(this.chartData.datasets[0].data);
        } else {
          this.dataSalary = [];
        }

        //console.log("ressss", this.dataSalary);
      });
    },
    checkplantoday() {
      this.emp_code = localStorage._empcode;
      console.log("this.emp_code", this.emp_code);
      this.startDateOfCalendar = this.date_picker_model.date;
      this.endDateOfCalendar = this.date_picker_model.date;

      DocumentService.getTimeCheckInByEmp(
        this.startDateOfCalendar,
        this.endDateOfCalendar,
        this.emp_code
      ).then(res => {
        this.clockinTime = moment(
          res.data[0].processTimes[0].processTimePlan.start_time1
        ).format("HH:mm");
        if (res.data[0].processTimes[0].processTimePlan.end_time1 != null) {
          this.clockoutTime = moment(
            res.data[0].processTimes[0].processTimePlan.end_time1
          ).format("HH:mm");
        } else if (
          res.data[0].processTimes[0].processTimePlan.end_time2 != null
        ) {
          this.clockoutTime = moment(
            res.data[0].processTimes[0].processTimePlan.end_time2
          ).format("HH:mm");
        } else if (
          res.data[0].processTimes[0].processTimePlan.end_time3 != null
        ) {
          this.clockoutTime = moment(
            res.data[0].processTimes[0].processTimePlan.end_time3
          ).format("HH:mm");
        } else {
          this.clockoutTime = moment(
            res.data[0].processTimes[0].processTimePlan.end_time4
          ).format("HH:mm");
        }
      });
    },
    thousandSep(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    setshowhourlateabsenceleave() {
      var curr = new Date();
      var firstDay = new Date(curr.getFullYear(), curr.getMonth(), 1);
      (this.Search = ""), (this.from_date = this.selectedformatDate(firstDay));
      this.to_date = this.selectedformatDate(curr);
      ProcessService.getSalaryTable(
        this.Branch,
        this.Department,
        this.Position,
        this.Search,
        this.from_date,
        this.to_date
      ).then(res => {
        this.total_Deduct = res.data[0];
        console.log("ssssssss", this.total_Deduct);
      });
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    showPayslip(docno, empcode) {
      window.open("#/PeviewPDF/" + docno + "/" + empcode, "_blank");

      //console.log(this.docno);
      //console.log(checkedValues);
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");

h2,
span,
p {
  font-family: "Kanit", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  display: block;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
  body {
    font-size: 0.5em;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 768px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  body {
    font-size: 0.5em;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  body {
    font-size: 1em;
  }
}

@media screen and (min-width: 1200px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
  body {
    font-size: 1em;
  }
  .display {
    height: 400px;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
  body {
    font-size: 1em;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
  body {
    font-size: 1em;
  }
}
</style>
